import { cookie } from '../utils';

class Assortment {
  constructor() {
    this.invokers = document.querySelectorAll('.js-assortment-invoker');
    if (!this.invokers || this.invokers.length < 1) return;
    this.bindEvents();
  }

  bindEvents() {
    this.invokers.forEach(invoker => invoker.addEventListener('click', Assortment.handleClick));
  }

  static handleClick(e) {
    e.preventDefault();
    const slug = e.target.dataset.assortment;
    const url = e.target.dataset.link;
    if (!slug || !url) return;
    cookie.set('city', slug);
    setTimeout(() => {
      window.location.href = url;
    }, 500);
  }
}

export default new Assortment();



// WEBPACK FOOTER //
// ./components/Assortment.js